import "./filters";
import "./plugins";
//import * as Sentry from "@sentry/vue";
import axios from "axios";
import Vue from "vue";
import FastApiAuthService from "@/auth/FastApiAuthService";
import CognitoAuthService from "@/auth/CognitoAuthService";
import KeyCloakAuthService from "@/auth/KeyCloakAuthService";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";


Vue.config.productionTip = false;
Vue.config.performance = false; 

axios.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    store.dispatch('setServerNotice', { code: null, msg: null } );
    return response;
  },
  function(error) {
    if(![400, 502, 504].includes(error.response.status)){
      store.dispatch('setServerNotice', { code: error.response.status, msg: error.response.statusText + " - " + error.response.data.detail } );
    }
    // Any status code that lie out of the range of 2xx cause this function to trigger
    if (!error.response) {
      return;
    }
    /*if (error.response.status === 401) {
      alert("Unauthorized");
    }*/
    if (
      error.response.status === 405 &&
      error.response.headers["x-status"] === "LOGGEDOUT"
    ) {
      window.location = "/loggedout";
    }
    if (error.response.status === 503) {
      return;
    }
    /*const errorCategory = parseInt(
      error.response.status.toString().substring(0, 1)
    );
    if (errorCategory === 5) {
      alert(`Error ${error.response.status}\nSomething went wrong`);
    }*/

    return Promise.reject(error);
  }
);

/*Sentry.init({
  Vue: Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_ENVIRONMENT,
  release: process.env.VUE_APP_RELEASE,
  logErrors: false,
  tracingOptions: {
    trackComponents: false
  }
});*/

function confirmAppDeployVersionAndReload(deployDate) {
  const vueInstance = new Vue();
  vueInstance.$bvModal.msgBoxOk(
    "The application has been updated to a new version. Click OK to continue.",
    {
      title: "Application Updated",
      size: "md",
      okVariant: "primary",
      okTitle: "OK",
      hideHeaderClose: false,
      centered: true
    }
  ).then(() => {
      // User clicked OK
      console.log("First deployment version set");
      localStorage.setItem("appDeployDate", deployDate);
      window.location.replace(
      window.location.origin + window.location.pathname + '?v=' + new Date().getTime());
    }
  );
}

function checkAppDeployVersion() {
  const CURRENT_DEPLOY_DATE = process.env.VUE_APP_DEPLOY_AT;
  const STORED_DEPLOY_DATE = localStorage.getItem("appDeployDate");
  /* Executed only on first deployment */
  if (STORED_DEPLOY_DATE === null) {
    confirmAppDeployVersionAndReload(CURRENT_DEPLOY_DATE);
    return false;
    
  }
  if (STORED_DEPLOY_DATE !== CURRENT_DEPLOY_DATE) {
      confirmAppDeployVersionAndReload(CURRENT_DEPLOY_DATE);
      return false;
  }

  const url = new URL(window.location.href);
  if (url.searchParams.has("v")) {
    url.searchParams.delete("v");
    window.history.replaceState({}, document.title, url.pathname); 
  }

    return true;
  }

if (process.env.VUE_APP_AUTH_PROVIDER === "fastapi") {

  const fs = new FastApiAuthService();
  fs.init().then(() => {
    mountAuthenticatedApp();
  });
}

if (process.env.VUE_APP_AUTH_PROVIDER === "keycloak") {
  const ks = new KeyCloakAuthService();
  ks.init().then(() => {
    mountAuthenticatedApp();
  });
}

if (process.env.VUE_APP_AUTH_PROVIDER === "cognito") {
  const cs = new CognitoAuthService();
  cs.init().then(() => {
    mountAuthenticatedApp();
  });
}

function mountAuthenticatedApp() {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
}
